import React, { Fragment, useState, useEffect } from 'react';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import { useLocation,useHistory  } from "react-router-dom";

import Select from '@material-ui/core/Select';
import clsx from 'clsx';
import {
  makeStyles,
  TextField
} from '@material-ui/core';
import StatusDataContext from '../../contexts/StatusDataContext';
import Header from '../headers/Header';
import Footer from '../footer/Footer';
import authService from '../../services/auth.service';
import userService from '../../services/user.service';
import Repairs from './offlineversion/Repairs';
import useRequest from '../../customHooks/useRequest';


import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import CsvAnita from './dataUploader/CsvAnita';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}



const useRowStyles = makeStyles({
    root: {
      '& > *': {
        borderBottom: 'unset',
      },
    },
  });
  


const useStyles = makeStyles((theme) => ({
  pageContainer: {
    minHeight: '100%',
    marginTop: '0px'
  },
  root: {
    margin: '20px 30px',
    marginBottom: '50px',
    padding: '20px 20px'
  },
  title: {
    color: 'var(--gmi-color)',
    textAlign: 'center'
  },
  legendContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '-15px',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
    }
  },
  legend: {
    display: 'flex'
  },
  legendText: {
    marginLeft: '2vh',
    marginRight: '2vh',
    color: 'var(--gmi-color)',
    fontSize: '0.8em'
  },
  legendGreen: {
    backgroundColor: 'var(--console-green)',
    alignSelf: 'center',
    height: '20px',
    width: '20px'
  },
  legendRed: {
    backgroundColor: 'var(--console-red)',
    alignSelf: 'center',
    height: '20px',
    width: '20px'
  },
  legendGrey: {
    backgroundColor: 'var(--console-grey)',
    alignSelf: 'center',
    height: '20px',
    width: '20px'
  },
  consoleContainer: {
    justifyContent: 'space-evenly'
  }
}));

const Report = ({ className, ...rest }) => {
  const location = useLocation();
  const classes = useStyles();
  const [statusData, setStatusData] = useState ([]);
  
  const [value, setValue] = React.useState(
   authService.getCurrentUser() || 'not connected'
  );
 
  const [consoleid, setConsoleid] = React.useState('EZ070');
  
  var [wspid, setWspid] = React.useState(0);
  const {data}  = useRequest("get", '/repair/'+consoleid);
  const consolesData = data;
  const handleChange = (event) => {
    setConsoleid(event.target.value);
   
  };

  useEffect(() => {
    const getUserData = async () => {
        
        const results = await userService.getAllConsoles();
        
        setStatusData(results.data)
      };
      getUserData();
     
  
   

  }, [])


  const [valuez, setValuez] = React.useState(0);

  const handleChangez = (event, newValue) => {
    setValuez(newValue);
  };

  let history = useHistory();

  const redirect = () => {
    history.push({pathname:'/app/divider/:uuid',
    state: {myFile:location.state.myFile, tabTemp:location.state.tabTemp, tabCH:location.state.tabCH, placementlink:location.state.placementlink, typeAnita:location.state.typeAnita, urlCaptureImage:location.state.urlCaptureImage}});
    window.location.reload();
  }
  let newDate = new Date()
let date = newDate.getDate();
let month = newDate.getMonth() + 1;
if(month<10)month="0"+month
if(date<10)date="0"+date
let year = newDate.getFullYear()+"-"+month+"-"+date;

  return (
    <StatusDataContext.Provider value={statusData}>
      <Fragment>
           <Header type={"client"} title={"CURING FILE SELECTION "}/>

       

        <div className={clsx(classes.pageContainer, className)}>
        
      <Box sx={{ width: '100%' ,justifyContent:'center'}}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider',width:'100%' }}>
        <Tabs value={valuez} onChange={handleChangez} aria-label="basic tabs ss">
          <Tab label="CSV UPLOAD" {...a11yProps(0)} />
          <Tab label="CONSOLE SELECTION " {...a11yProps(1)} />
        </Tabs>
      </Box>
     
      <TabPanel value={valuez} index={0}>
      <div  className="stopwatch" >
      <CsvAnita  tabCH={location.state.tabCH} file={location.state.myFile} tabTemp={location.state.tabTemp} placementlink={location.state.placementlink} typeAnita={location.state.typeAnita}></CsvAnita>
      <br/><button onClick={redirect} className="stopwatch-btn stopwatch-btn-gre">Go forward</button>
      <br/> <br/> 
      </div>
      </TabPanel>
     
      <TabPanel value={valuez} index={1}>
      <div  className="stopwatch" >
      <br/><br/><br/>
      <span style={{width:"80%"}}>
     WORK IN PROGRESS FOR THE ONLINE VERSION
    </span></div>
      </TabPanel>
    </Box>
   
     
    
        </div>
        <Box flexGrow={1} />
        
        <Footer type="main"/>
      </Fragment>
    </StatusDataContext.Provider>
  )
}
/*

 <h3 style={{color:'red'}}>Select the console and the date of the repair : </h3>
      
      <InputLabel id="demo-simple-select-helper-label">Console S/N : </InputLabel>
       
      <Select
          labelId="demo-simple-select-label"
          label="aa"
          id="demo-simple-select"
          value={consoleid}
          onChange={handleChange}
        >
            {statusData.map(home => <MenuItem value={home.uuid}>{home.console_id}</MenuItem>)}
          
        </Select> 
        <br/><br/><br/>
        <InputLabel id="demo-simple-select-helper-label">Keyword associated with repair  : </InputLabel>
     <TextField></TextField>
     <br/><br/><br/>
<TextField
    id="date"
    label="Searching from :"
    type="date"
    defaultValue={year}
    className={classes.textField}
    InputLabelProps={{
      shrink: true,
    }}
  />
  <br/><br/><br/>

<TextField
    id="date"
    label="Searching to :"
    type="date"
    defaultValue={year}
    className={classes.textField}
    InputLabelProps={{
      shrink: true,
    }}
  />
  <br/><br/><br/>
        <button className="stopwatch-btn stopwatch-btn-gre">Search</button>
    
        <br/><br/><br/>
        <div  className="stopwatch" >
    <Repairs style={{marginLeft:"70px"}} consoleid={consoleid} ></Repairs>
    </div>
*/
export default Report;
